/**
 * Get current GPS position from the browser.
 * Returns null silently if geolocation is unavailable or denied.
 */
export function getCurrentPosition(): Promise<{ lat: number; lng: number } | null> {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      console.warn('[GPS] navigator.geolocation not available');
      resolve(null);
      return;
    }

    const onSuccess = (position: GeolocationPosition) => {
      const result = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      console.log('[GPS] Position obtained:', result);
      resolve(result);
    };

    console.log('[GPS] Requesting position (high accuracy)...');
    navigator.geolocation.getCurrentPosition(
      onSuccess,
      (error) => {
        console.warn('[GPS] High accuracy failed:', error.code, error.message);
        console.log('[GPS] Retrying with low accuracy...');
        navigator.geolocation.getCurrentPosition(
          onSuccess,
          (fallbackError) => {
            console.warn('[GPS] Low accuracy also failed:', fallbackError.code, fallbackError.message);
            resolve(null);
          },
          { enableHighAccuracy: false, timeout: 10000, maximumAge: 60000 }
        );
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    );
  });
}
